import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { Loader2, Clock, Mail } from "lucide-react";

export default function AdminRecruiterWaitlist() {
  const [rows, setRows] = useState(null);

  useEffect(() => { api.get("/recruiter-waitlist").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader overline="Recruiting-partner demand" title="Recruiter Waitlist">
        {rows && <span className="text-sm text-muted-foreground">{rows.length} signed up</span>}
      </PageHeader>
      <div className="p-8">
        {!rows && <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        {rows && rows.length === 0 && <Empty icon={Clock} title="No signups yet" hint="Recruiter waitlist entries from /for-recruiters will appear here." />}
        {rows && rows.length > 0 && (
          <div className="border border-black/10" data-testid="waitlist-table">
            <div className="grid grid-cols-12 px-5 py-3 border-b border-black/10 overline text-[0.55rem] bg-white">
              <span className="col-span-3">Name</span><span className="col-span-3">Email</span><span className="col-span-2">Agency</span><span className="col-span-3">Roles</span><span className="col-span-1">Date</span>
            </div>
            {rows.map((r) => (
              <div key={r.id} className="grid grid-cols-12 px-5 py-4 border-b border-black/5 bg-white items-center text-sm" data-testid={`waitlist-row-${r.id}`}>
                <span className="col-span-3 font-medium">{r.full_name}</span>
                <a href={`mailto:${r.email}`} className="col-span-3 text-primary hover:underline flex items-center gap-1 truncate"><Mail className="h-3 w-3 shrink-0" /> {r.email}</a>
                <span className="col-span-2 text-muted-foreground truncate">{r.agency || "—"}</span>
                <span className="col-span-3 text-muted-foreground truncate">{r.roles || "—"}</span>
                <span className="col-span-1 text-xs text-muted-foreground">{new Date(r.created_at).toLocaleDateString()}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
